import React, { useEffect, useState, useCallback } from "react";
import { environment } from "environments/environment";
import { SelectCustom } from "../../../Select";
import { useCreditSelector } from "../../../../stores/product/product.store";
import { CreditState } from "../../../../stores/credit/credit-state.interface";
import { useCreditDispatch } from "../../../../stores/credit/credit.store";
import { setShipping } from "../../../../stores/credit/credit.reducer";

interface SboxProps {}

export const Sbox: React.FC<SboxProps> = () => {
    const translateText = useCreditSelector((state: CreditState) => state.text);
    const [zones, setZones] = useState<{ label: string; value: string }[]>([]);
    const [cities, setCities] = useState<{ label: string; value: string }[]>([]);
    const [pickups, setPickups] = useState<{ label: string; value: string }[]>([]);
    const [selectedZone, setSelectedZone] = useState<{ label: string; value: string } | null>(null);
    const [selectedCity, setSelectedCity] = useState<{ label: string; value: string } | null>(null);
    const [selectedPickup, setSelectedPickup] = useState<{ label: string; value: string } | null>(null);
    const dispatch = useCreditDispatch();

    useEffect(() => {
        fetch(environment.urls.credits.getCities, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ optionId: 6 })
        })
            .then(response => response.json())
            .then(data => {
                const formattedCities = data.map((city: any) => ({
                    label: city.name,
                    value: city.code
                }));
                setCities(formattedCities);
            })
            .catch(error => console.error('Error fetching cities:', error));
    }, []);

    const onChangeCity = useCallback((option: { label: string; value: string } | null) => {
        setSelectedCity(option);
        setSelectedZone(null);
        setSelectedPickup(null);

        setZones([]);
        setPickups([]);

        if(!option) return ;

        fetch(environment.urls.credits.getRegions, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ cityId: option.value, optionId: 6 })
        })
            .then(response => response.json())
            .then(data => {
                const formattedZones = data.map((zone: any) => ({
                    label: zone.name,
                    value: zone.code
                }));
                setZones(formattedZones);
            })
            .catch(error => console.error('Error fetching cities:', error));
    }, []);

    const onChangeZone = (option: { label: string; value: string } | null) => {
        setSelectedZone(option);
        setSelectedPickup(null);
        setPickups([]);

        if(!option) return ;

        fetch(environment.urls.credits.getPickups, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ zoneId: option.value })
        })
            .then(response => response.json())
            .then(data => {
                const formattedPickups = data.map((pickup: any) => ({
                    label: pickup.name,
                    value: pickup.code
                }));
                setPickups(formattedPickups);
            })
            .catch(error => console.error('Error fetching pickups:', error));
    };

    const onChangePickup = (option: { label: string; value: string } | null) => {
        setSelectedPickup(option);
        dispatch(setShipping(
            {
                zone: selectedZone!.value,
                cityId: selectedCity!.value,
                pickup: option!.value,
            }
        ));
    };


    return (
        <div>
            <div className="w-full mb-6">
                <label htmlFor="region" className="text-sm font-medium mb-3 block text-black">{ translateText.region }<span
                    className="text-red-500"> *</span></label>
                <SelectCustom options={ cities } onChange={ onChangeCity } value={ selectedCity } />
            </div>
            { zones.length > 0 && (
                <div className="w-full mb-6">
                    <label htmlFor="city"
                           className="text-sm font-medium mb-3 block text-black">{ translateText.sector }<span
                    className="text-red-500"> *</span></label>
                    <SelectCustom options={ zones } onChange={ onChangeZone } value={ selectedZone }/>
                </div>
            ) }
            { pickups.length > 0 && (
                <div className="w-full mb-6">
                    <label htmlFor="pickup"
                           className="text-sm font-medium mb-3 block text-black">{ translateText.pickup }<span
                    className="text-red-500"> *</span></label>
                    <SelectCustom options={ pickups } onChange={ onChangePickup } value={ selectedPickup }/>
                </div>
            ) }
        </div>
    );
};
